import { useState } from "react";
import { EventAvailabilityDetails } from "features/types";

export const useDeferredSeatAssignment = () => {
  const [rsvpDialogVisible, setRsvpDialogVisible] = useState(false);
  const [rsvpEvent, setRsvpEvent] = useState<EventAvailabilityDetails | null>(
    null,
  );

  const handleDeferredSeatAssignment = (
    item: EventAvailabilityDetails,
    onNormalFlow: () => void,
  ) => {
    // Deferred seat assignment: show RSVP dialog instead of seat selection
    if (item.deferredSeatAssignmentEnabled) {
      setRsvpEvent(item);
      setRsvpDialogVisible(true);
      return;
    }

    onNormalFlow();
  };

  return {
    rsvpDialogVisible,
    setRsvpDialogVisible,
    rsvpEvent,
    setRsvpEvent,
    handleDeferredSeatAssignment,
  };
};
